import { UNIT_TRUST_INVESTMENT_ACCOUNT } from 'srcAlias/client/enums/productDescriptionCode';
import { UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY } from 'srcAlias/client/enums/productCategory';
import translations from 'contentAlias';
import { get } from 'lodash-es';
export const validateData = (values) => {
  const invalidData = {};
  if (
    values.product !==
      `${UNIT_TRUST_INVESTMENT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}` &&
    values.tncEquityCheckbox !== true
  ) {
    invalidData.tncEquityCheckbox = get(
      translations,
      'customer.declaration.checkboxNonUTErrorMessage',
      ''
    );
  }
  if (
    values.product ===
      `${UNIT_TRUST_INVESTMENT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}` &&
    values.tncUTCheckbox !== true
  ) {
    invalidData.tncUTCheckbox = get(
      translations,
      'customer.declaration.checkboxUTErrorMessage',
      ''
    );
  }
  return invalidData;
};
